import * as mondrian from "mondrian-tokens/dist/claro-tokens-latest.module";
const arr = [
  "fontSizeXxxs",
  "fontSizeXxs",
  "fontSizeXs",
  "fontSizeSm",
  "fontSizeMd",
  "fontSizeLg",
  "fontSizeXl",
  "fontSizeXxl",
];
var newObj = { ...mondrian };
arr.map((el) => {
  let item = newObj[el];
  let value = `${Number(item.split("px")[0]) / 16}rem`;
  return (newObj[el] = value);
});
export default newObj;
